export default [
	{
		type: 'weapon',
		slug: 'sword',
		targets: [ 'empty' ],
		levels: [
			{ attack: 1, durability: 3 },
			{ attack: 2, durability: 2 },
			{ attack: 3, durability: 1 },
		],
		triggers: [],
		fr: {
			name: "Épée",
			description: "-"
		},
		en: {
			name: "Sword",
			description: "-"
		}
	},
	{
		type: 'weapon',
		slug: 'golden-sword',
		targets: [ 'empty' ],
		levels: [
			{ attack: 1, durability: 3 },
			{ attack: 2, durability: 2 },
			{ attack: 3, durability: 1 },
		],
		triggers: [
			{
				on: 'after-attack',
				method: 'gain_gold',
				value: 1
			}
		],
		fr: {
			name: "Épée dorée",
			description: "Gagne 1 émeraude après chaque coup porté."
		},
		en: {
			name: "Golden sword",
			description: "Gains 1 emerald after each hit."
		}
	},
	{
		type: 'weapon',
		slug: 'dagger',
		targets: [ 'empty' ],
		levels: [
			{ attack: 1, durability: 3 },
			{ attack: 1, durability: 4 },
			{ attack: 1, durability: 5 },
		],
		triggers: [],
		fr: {
			name: "Dague",
			description: "Attaque +2 si vous portez une deuxième dague."
		},
		en: {
			name: "Dagger",
			description: "Attack +2 if you have a second dagger."
		}
	},
	{
		type: 'weapon',
		slug: 'hammer',
		targets: [ 'empty' ],
		levels: [
			{ attack: 1, durability: 3 },
			{ attack: 2, durability: 2 },
			{ attack: 3, durability: 1 },
		],
		triggers: [],
		fr: {
			name: "Marteau",
			description: "-"
		},
		en: {
			name: "Hammer",
			description: "-"
		}
	},
	{
		type: 'weapon',
		slug: 'staff',
		targets: [ 'empty' ],
		levels: [
			{ attack: 1, durability: 3 },
			{ attack: 2, durability: 2 },
			{ attack: 3, durability: 1 },
		],
		triggers: [
			{
				on: 'after-attack',
				method: 'deal_damage_to_adjacent_enemy',
				value: 1
			}
		],
		fr: {
			name: "Bâton",
			description: "Inflige également 1 dégât à l'ennemi derrière l'adversaire."
		},
		en: {
			name: "Staff",
			description: "Also inflicts 1 damage to the enemy behind the opponent."
		}
	},
	{
		type: 'weapon',
		slug: 'mace',
		targets: [ 'empty' ],
		levels: [
			{ attack: 1, durability: 3 },
			{ attack: 2, durability: 2 },
			{ attack: 3, durability: 1 },
		],
		triggers: [
			{
				on: 'after-attack',
				method: 'push_opponent'
			}
		],
		fr: {
			name: "Massue",
			description: "Pousse l'ennemi après l'avoir attaqué."
		},
		en: {
			name: "Mace",
			description: "Pushes the enemy after attacking him."
		}
	},
	{
		type: 'weapon',
		slug: 'axe',
		targets: [ 'empty' ],
		levels: [
			{ attack: 1, durability: 3 },
			{ attack: 2, durability: 2 },
			{ attack: 3, durability: 1 },
		],
		triggers: [
			{
				on: 'after-attack',
				method: 'gain_attack',
				value: 1
			}
		],
		fr: {
			name: "Hache",
			description: "Attaque +1 après chaque coup porté."
		},
		en: {
			name: "Axe",
			description: "Attack +1 after each hit."
		}
	},
	{
		type: 'weapon',
		slug: 'lance',
		targets: [ 'empty' ],
		levels: [
			{ attack: 1, durability: 3 },
			{ attack: 2, durability: 2 },
			{ attack: 3, durability: 1 },
		],
		triggers: [],
		fr: {
			name: "Lance",
			description: "Attaque +1 pour chaque ennemi en jeu."
		},
		en: {
			name: "Spear",
			description: "Attack +1 for each enemy in play."
		}
	},
]